export const PATHS = {
  MAIN: {
    path: '/',
    label: 'Main',
    breadcrumbs: true,
    exact: true,
    sidebar: false,
  },
  // Content pages:
  MY_REFLEX_COMPOSERS: {
    path: '/File Management/Online composers',
    label: 'Online Composers',
    breadcrumbs: false,
    exact: false,
    sidebar: true,
  },
  SHARED_WITH_ME: {
    path: '/File Management/Shared with me',
    label: 'Shared With Me',
    breadcrumbs: false,
    exact: true,
    sidebar: true,
  },
  MY_FOLDERS: {
    path: '/File Management/My folders',
    label: 'My Folders',
    breadcrumbs: false,
    exact: true,
    sidebar: true,
  },
  COLLABORATIVE_FOLDERS: {
    path: '/File Management/Collaborative Folders',
    label: 'Parent Folders',
    breadcrumbs: false,
    exact: true,
    sidebar: true,
  },
  ALL_CONTENT: {
    path: '/File Management/All Content',
    label: 'Admin',
    breadcrumbs: false,
    exact: true,
    sidebar: false,
  },
  ALL_CONTENT_VIDEOFEEDS: {
    path: '/File Management/All Content Videofeeds',
    label: 'All Videofeeds',
    breadcrumbs: false,
    exact: true,
    sidebar: false,
  },
  VIDEOFEEDS_LIST: {
    path: '/File Management/My folders/Videofeeds',
    label: 'Videofeeds',
    breadcrumbs: false,
    exact: false,
    sidebar: true,
  },
  COLLABORATIVE_VIDEOFEEDS_LIST: {
    path: '/File Management/Collaborative Folders/Videofeeds',
    label: 'Collaborative Videofeeds',
    breadcrumbs: false,
    exact: false,
    sidebar: true,
  },
  TIMELINE: {
    path: '/File Management/Timeline',
    label: 'Timeline',
    breadcrumbs: false,
    exact: false,
    sidebar: true,
  },
  COMPOSER_PAGE: {
    path: '/File Management/Composer',
    label: 'Composer',
    breadcrumbs: false,
    exact: false,
    sidebar: true,
  },
  FILE_MANAGEMENT: {
    path: '/File Management',
    label: 'File Management',
    breadcrumbs: false,
    exact: false,
    sidebar: true,
  },
  SHARED_VIDEOFEEDS_LIST: {
    path: '/File Management/Shared with me/videofeeds',
    label: 'Videofeeds',
    breadcrumbs: false,
    exact: false,
    sidebar: true,
  },
  // MANAGEMENT ROUTES:
  ADMIN_PAGE: {
    path: '/admin',
    label: 'Admin page',
    breadcrumbs: false,
    exact: false,
    sidebar: false,
  },
  SA_USERS_LIST: {
    path: '/admin/users',
    label: 'Users',
    breadcrumbs: false,
    exact: true,
    sidebar: false,
  },
  SA_ORGANIZATION_STORAGE: {
    path: '/admin/organizations/:organizationId/storage',
    label: 'S3 Storage Details',
    breadcrumbs: false,
    exact: true,
    sidebar: false,
  },
  USERS_LIST: {
    path: '/File Management/users',
    label: 'Users',
    breadcrumbs: false,
    exact: false,
    sidebar: false,
  },
  CHILD_ORG_LIST: {
    path: '/File Management/childOrgs',
    label: 'Child organisations',
    breadcrumbs: false,
    exact: false,
    sidebar: false,
  },
  ORG_GROUPS_MANAGEMENT: {
    path: '/File Management/org-groups',
    label: 'Groups Management',
    breadcrumbs: false,
    exact: true,
    sidebar: false,
  },
  GROUPS_MANAGEMENT: {
    path: '/File Management/groups',
    label: 'Groups Management',
    breadcrumbs: false,
    exact: true,
    sidebar: false,
  },
  SUB_GROUPS_MANAGEMENT: {
    path: '/File Management/groups/subgroups/',
    label: 'SubGroups Management',
    breadcrumbs: false,
    exact: false,
    sidebar: false,
  },
  SUB_GROUP_VIEW: {
    path: '/File Management/groups/subgroup-view/',
    label: 'SubGroups Management',
    breadcrumbs: false,
    exact: false,
    sidebar: false,
  },
};
